import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBreachIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", {}) }),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#8e6e52",
			children: [/* @__PURE__ */ _jsx("path", {
				stroke: "none",
				d: "M 64 125 C 55.76374053955078 125 47.77542114257813 123.387580871582 40.25696182250977 120.2075424194336 C 36.64311981201172 118.6790237426758 33.15731811523438 116.7869567871094 29.89641952514648 114.5839385986328 C 26.66571998596191 112.4013214111328 23.62759971618652 109.8946380615234 20.86647987365723 107.1335220336914 C 18.10536003112793 104.3723983764648 15.5986795425415 101.3342819213867 13.41606044769287 98.10357666015625 C 11.21304035186768 94.84268188476563 9.320980072021484 91.35688018798828 7.792459964752197 87.7430419921875 C 4.612420082092285 80.22457885742188 3 72.23625946044922 3 64 C 3 55.76374053955078 4.612420082092285 47.77542114257813 7.792459964752197 40.25696182250977 C 9.320980072021484 36.64311981201172 11.21304035186768 33.15731811523438 13.41606044769287 29.89641952514648 C 15.5986795425415 26.66571998596191 18.10536003112793 23.62759971618652 20.86647987365723 20.86647987365723 C 23.62759971618652 18.10536003112793 26.66571998596191 15.5986795425415 29.89641952514648 13.41606044769287 C 33.15731811523438 11.21304035186768 36.64311981201172 9.320980072021484 40.25696182250977 7.792459964752197 C 47.77542114257813 4.612420082092285 55.76374053955078 3 64 3 C 72.23625946044922 3 80.22457885742188 4.612420082092285 87.7430419921875 7.792459964752197 C 91.35688018798828 9.320980072021484 94.84268188476563 11.21304035186768 98.10357666015625 13.41606044769287 C 101.3342819213867 15.5986795425415 104.3723983764648 18.10536003112793 107.1335220336914 20.86647987365723 C 109.8946380615234 23.62759971618652 112.4013214111328 26.66571998596191 114.5839385986328 29.89641952514648 C 116.7869567871094 33.15731811523438 118.6790237426758 36.64311981201172 120.2075424194336 40.25696182250977 C 123.387580871582 47.77542114257813 125 55.76374053955078 125 64 C 125 72.23625946044922 123.387580871582 80.22457885742188 120.2075424194336 87.7430419921875 C 118.6790237426758 91.35688018798828 116.7869567871094 94.84268188476563 114.5839385986328 98.10357666015625 C 112.4013214111328 101.3342819213867 109.8946380615234 104.3723983764648 107.1335220336914 107.1335220336914 C 104.3723983764648 109.8946380615234 101.3342819213867 112.4013214111328 98.10357666015625 114.5839385986328 C 94.84268188476563 116.7869567871094 91.35688018798828 118.6790237426758 87.7430419921875 120.2075424194336 C 80.22457885742188 123.387580871582 72.23625946044922 125 64 125 Z"
			}), /* @__PURE__ */ _jsx("path", {
				stroke: "none",
				fill: "#3b3b3b",
				d: "M 64 6 C 32.01869201660156 6 6 32.01869201660156 6 64 C 6 95.98130798339844 32.01869201660156 122 64 122 C 95.98130798339844 122 122 95.98130798339844 122 64 C 122 32.01869201660156 95.98130798339844 6 64 6 M 64 0 C 99.34622192382813 0 128 28.65378570556641 128 64 C 128 99.34622192382813 99.34622192382813 128 64 128 C 28.65378570556641 128 0 99.34622192382813 0 64 C 0 28.65378570556641 28.65378570556641 0 64 0 Z"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "#3b3b3b",
			strokeWidth: "6px",
			d: "M.88.545,22,24",
			transform: "translate(56.5 2.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "#3b3b3b",
			strokeWidth: "6px",
			d: "M22,0,0,25",
			transform: "translate(56.5 22.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "#3b3b3b",
			strokeWidth: "6px",
			d: "M24.8,0,0,27.782",
			transform: "translate(53.7 64.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "#3b3b3b",
			strokeWidth: "6px",
			d: "M0,0,22,25",
			transform: "translate(56.5 43.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "#3b3b3b",
			strokeWidth: "6px",
			d: "M0,0,20.935,33.382",
			transform: "translate(54.831 89.265)"
		})
	]
});
export default SvgBreachIcon;
